export function mod(val: number, by: number): number {
  return ((val % by) + by) % by;
}
